<div style="height: 100%">
  <ngx-monaco-editor
    style="height: 100%"
    [options]="editorOptions"
    [(ngModel)]="content"
  ></ngx-monaco-editor>
</div>
